import { faArrowUpRightFromSquare } from '@fortawesome/free-solid-svg-icons';

import { Icon, Link } from 'apps/shared/scripts/components';

import {
  footerLinkClassName,
  footerLinkWrapperClassName,
  linkIconClassName,
  widgetFooterClassName,
} from './styles';

interface Props {
  id: string;
}

const WidgetFooter = ({ id }: Props) => {
  return (
    <div className={widgetFooterClassName}>
      <div className={footerLinkWrapperClassName}>
        <Link
          className={footerLinkClassName}
          to={`/dashboard/cards/${id}`}
          target="_blank"
          rel="noopener noreferrer"
        >
          Card details
          <Icon className={linkIconClassName} fa={faArrowUpRightFromSquare} />
        </Link>
      </div>
    </div>
  );
};

WidgetFooter.displayName = 'WidgetFooter';

export default WidgetFooter;
